/**
 * Is Exists
 */
const isExists = <T>(target: T | undefined): target is T => !!target;

export { isExists };
